import { render, staticRenderFns } from "./BStaticTable.vue?vue&type=template&id=a0b30bce&"
import script from "./BStaticTable.vue?vue&type=script&lang=js&"
export * from "./BStaticTable.vue?vue&type=script&lang=js&"
import style0 from "./BStaticTable.vue?vue&type=style&index=0&id=a0b30bce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports